module.exports = __webpack_public_path__ + "img/data-internent.01eee847.svg";